import React from "react";
import { string, func, number } from 'prop-types';
import styled from 'styled-components';
import Text from './Text';

var UploaderFigure = function UploaderFigure(_ref) {
  var onClick = _ref.onClick,
      imageUrl = _ref.imageUrl,
      imageAlt = _ref.imageAlt,
      placeholderMessage = _ref.placeholderMessage,
      figureHeight = _ref.figureHeight;
  return /*#__PURE__*/React.createElement(Figure, {
    onClick: onClick,
    onKeyDown: onClick,
    role: "button",
    tabIndex: 0,
    figureHeight: figureHeight
  }, imageUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "figure-overflow-icon"
  }, "Delete"), /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: imageAlt || 'Uploaded pic'
  })) : /*#__PURE__*/React.createElement("div", {
    className: "figure-placeholder"
  }, "+", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text, {
    isHtml: true,
    isSmall: true,
    textColor: "#bdbdbd",
    lineHeight: "17px"
  }, placeholderMessage)));
};

var Figure = styled.div.withConfig({
  displayName: "ImageUploaderFigure__Figure",
  componentId: "sc-1uat962-0"
})(["position:relative;height:100%;width:100%;border:1px dashed lightgrey;cursor:pointer;&:not(:hover):not(:focus) > .figure-overflow-icon{display:none;}> .figure-overflow-icon{position:absolute;color:white;width:100%;height:100%;background-color:rgba(0,0,0,.4);text-align:center;display:flex;justify-content:center;flex-direction:row;align-items:center;}> img{width:100%;}> .figure-placeholder{text-align:center;color:grey;font-size:30px;cursor:pointer;pointer-events:none;display:flex;flex-direction:column;justify-content:center;", "}"], function (props) {
  return !props.figureHeight ? 'min-height: 100px;' : "min-height:".concat(props.figureHeight, "px;");
});
UploaderFigure.propTypes = {
  onClick: func.isRequired,
  imageUrl: string,
  imageAlt: string,
  placeholderMessage: string,
  figureHeight: number
};
export default UploaderFigure;